import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { FavoriteSku } from 'src/app/standalone/favorites-star/favorite-sku.model';

@Injectable({
  providedIn: 'root',
})
export class FavoriteApiService {
  protected baseUrl = this.agrEnv.APIM_BASE_URL + '/cart-v2-service';

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) protected agrEnv: AgrEnvironment,
  ) {}

  getFavorites(profileId: number): Observable<{ favorites: FavoriteSku[] }> {
    return this.http.get<{ favorites: FavoriteSku[] }>(`${this.baseUrl}/favorites/${profileId}`);
  }

  addFavorite(profileId: number, skuId: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/favorites/${profileId}/${skuId}`, {});
  }

  removeFavorite(profileId: number, skuId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/favorites/${profileId}/${skuId}`);
  }
}
